import { secondsToMilliseconds } from "date-fns";
import { Statsig } from "../../../statsig/StatsigProvider";
import { dynamicConfig } from "../../../statsig/gates";

const DEFAULT_ZOOM_FAILOVER_CONFIG = {
  joinRetries: 5,
  joinRetryDelayMs: secondsToMilliseconds(1),
};

export function getZoomFailoverConfig() {
  return {
    ...DEFAULT_ZOOM_FAILOVER_CONFIG,
    ...Statsig.getDynamicConfig(dynamicConfig).get<
      typeof DEFAULT_ZOOM_FAILOVER_CONFIG
    >("zoom_failover_config", DEFAULT_ZOOM_FAILOVER_CONFIG),
  };
}
